import React, { memo, ReactNode } from 'react';

import Tooltip from '@plasma/ui.display.tooltip';
import PopConfirm from '@plasma/ui.feedback.pop-confirm';
import Button from '@plasma/ui.general.button';
import Select from '@plasma/ui.input.select';
import Modal from '@plasma/ui.layout.modal';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import LoadingComponent from '../../components/Loding-component/LoadingComponent';
import TopBarThemed from '../../components/top-bar-themed';
import useRoleBaseDesignHook from './role-base-design.hook';
import * as styled from './role-base-design.styles';
import { NormalPlasmaButton, NormalPlasmaSelect } from './role-base-design.styles';
import themes from './themes';

// import usePdfToImages from '../../services/Utils/PdfToImage';

const { Option } = Select;
export interface RoleBaseDesignProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = RoleBaseDesignProps & ThemeOverride;

function RoleBaseDesign(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const superUserRole = sessionStorage.getItem('superUserRole');

  const {
    t,
    showPhoto,
    buttons,
    rollPass,
    showModal,
    rollPassInModal,
    distinctProdType,
    showButtonBox,
    iFrameSrc,
    guidByProd,
    guidByProdArray,
    pageNumber,
    roleID,
    buttonTitle,
    handleRollPassChange,
    handleGoHome,
    handleButtonClick,
    handleShowModal,
    handleSaveFromModal,
    HandleModalCancel,
    handleRollPassChangeInModal,
    handleFileUpload,
    handleButtonBoxOpen,
    handleNextPage,
    handlePreviousPage,
    setButtonTitle,
    handleDeletePDF,
    setpageNumber,
    loadingFile,
  } = useRoleBaseDesignHook(props);

  // const images = usePdfToImages(iFrameSrc);
  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.RoleBaseDesign className={`role-base-design ${className ?? ''}`.trim()} style={style}>
        <TopBarThemed topHeading={t('roll-pass-design')} />
        {loadingFile && <LoadingComponent />}

        <Modal
          title={t('upload-files')}
          width={'fit-content'}
          okText={t('save')}
          cancelText={t('cancel')}
          visible={showModal}
          onCancel={() => HandleModalCancel()}
          onOk={() => handleSaveFromModal()}
          destroyOnClose
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'linear-gradient(to top left, #f0f0f5, #33adff55)',
              padding: '15px',
              borderRadius: '5px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4vh', marginTop: '3vh' }}>
              <div
                style={{
                  height: '3vh',
                  width: '6vw',
                  fontWeight: 'bold',
                  marginRight: '3vw',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t('roll-pass')}
              </div>

              <NormalPlasmaSelect
                style={{ minWidth: '8vw', width: 'fit-content', border: '1px solid #75a3a3', borderRadius: '3px' }}
                dropdownStyle={{ minWidth: '10vw' }}
                placeholder={t('select-roll-pass')}
                allowClear
                onChange={handleRollPassChangeInModal}
                value={rollPassInModal}
              >
                {distinctProdType?.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
              </NormalPlasmaSelect>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2vh' }}>
              <div
                style={{
                  height: '3vh',
                  width: '6vw',
                  fontWeight: 'bold',
                  marginRight: '3vw',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t('select-pdf')}
              </div>
              <input type="file" accept="application/pdf" onChange={handleFileUpload} />
            </div>
          </div>
        </Modal>

        <div>
          <div style={{ marginTop: '1.5vh', display: 'flex', justifyContent: 'flex-end', overflow: 'hidden' }}>
            {showPhoto && (
              <div
                style={{
                  border: '2px solid #b0ccda',
                  borderRadius: '5px',
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '0.5vh',
                  marginLeft: '0.2vh',
                  flex: '1',
                  backgroundColor: '#cccccc99',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {guidByProd && (
                    <div style={{ display: 'flex' }}>
                      <PopConfirm
                        //title = 'Are you sure you want to delete this family ?'
                        title={<div>{t('delete-confirmation-text')} ?</div>}
                        onConfirm={handleDeletePDF}
                        okText={t('delete')}
                        cancelText={t('cancel')}
                      >
                        <Button
                          style={{ width: '2vw', borderRadius: '2px' }}
                          prefixIcon={{ name: 'delete' }}
                          disabled={!superUserRole}
                        />
                      </PopConfirm>
                    </div>
                  )}
                </div>

                <iframe src={iFrameSrc} title="PDF" style={{ height: '100%', width: '100%' }} />

                <h3
                  style={{
                    borderRadius: '2px',
                    fontSize: '1.2vh',
                    marginLeft: '8px',
                    backgroundColor: '#f2eded99',
                    fontWeight: 'bold',
                    color: '#0066ccf0',
                  }}
                >
                  {buttonTitle}
                </h3>
              </div>
            )}

            <styled.ButtonContainer style={{ marginBottom: 0 }} showButtonBox={showButtonBox}>
              {/* <styled.ArrowButton
                  showButtonBox={showButtonBox}
                  onClick={handleButtonBoxOpen}
                  prefixIcon={{name: showButtonBox ? 'arrow_forward_ios' : 'arrow_back_ios'}}
                /> */}

              <div style={{ display: 'flex', padding: '2px', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: '17px', fontWeight: 'bold' }}>{t('roll-pass')}</div>

                {superUserRole && (
                  <NormalPlasmaButton
                    style={{ borderRadius: '4px' }}
                    title={t('upload-files')}
                    onClick={handleShowModal}
                  >
                    {t('upload-files')}
                  </NormalPlasmaButton>
                )}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '5px',
                  borderTop: '2px solid black',
                  alignItems: 'center',
                  overflowY: 'auto',
                }}
              >
                {buttons?.map((button, index) => (
                  <styled.ThemedButton
                    key={index}
                    style={{ borderRadius: '4px' }}
                    isActive={button.title === buttonTitle}
                    title={button.title}
                    onClick={() => handleButtonClick(button.title)}
                  />
                ))}
              </div>
            </styled.ButtonContainer>
          </div>
        </div>
      </styled.RoleBaseDesign>
    </ThemeProvider>
  );
}

export default memo(RoleBaseDesign) as unknown as typeof RoleBaseDesign;
